module.exports = __webpack_public_path__ + "img/logo.4bb82f35.svg";